<script setup>
import { ref, toRefs, watch } from "vue";

const props = defineProps({
  placeholder: {
    type: String,
    default: "메일 제목을 입력하세요.",
  },
  value: {
    type: String,
  },
  label: {
    type: String,
    required: true,
  },
  errorMsg: {
    type: String,
  },
  required: {
    type: Boolean,
  },
  countLength: {
    type: Boolean,
    default: true,
  },
  maxlength: {
    type: [Number, String],
    default: 100,
  },
  prepend: {
    type: String,
  },
});
const inputVal = ref("");
const active = ref(false);
const cursorPosition = ref(0);

const items = [
  {
    category: "주소 정보",
    items: [
      {
        text: "이름",
        value: "name",
      },
    ],
  },
  {
    category: "캠퍼스 정보",
    items: [
      {
        text: "캠퍼스 이름",
        value: "campusName",
      },
      // 2차 업데이트
      // {
      //   text: "회사명",
      //   value: "companyName",
      // },
      // {
      //   text: "대표번호",
      //   value: "companyNum",
      // },
      // {
      //   text: "대표이메일",
      //   value: "companyEmail",
      // },
      // {
      //   text: "대표주소",
      //   value: "companyAddress",
      // },
    ],
  },
];

const emit = defineEmits(["input"]);
const { label, value, required, countLength, maxlength, errorMsg } =
  toRefs(props);

const onBlur = (__, target) => {
  cursorPosition.value = target.selectionStart;
};

const onClick = (val) => {
  const addStr = `{{${val.text}}}`;

  //  input value에서 cursorPosition 이전 value
  const preCursorText = inputVal.value.slice(0, cursorPosition.value);
  // input value에서 cursorPosition 이후 value
  const afterCursorText = inputVal.value.slice(cursorPosition.value);

  // maxlength 체크
  if ((preCursorText + addStr + afterCursorText).length < maxlength.value) {
    inputVal.value = preCursorText + addStr + afterCursorText;
    emit("input", inputVal.value);
    cursorPosition.value += addStr.length; // 커서 위치 업데이트
  }
  active.value = false;
};

watch(
  value,
  (value) => {
    if (value) {
      inputVal.value = value;
    }
  },
  { immediate: true }
);
</script>

<template>
  <div>
    <p-input
      :placeholder="placeholder"
      :label="label"
      :required="required"
      :countLength="countLength"
      :maxlength="maxlength"
      :errorMsg="errorMsg"
      v-model="inputVal"
      @blur="onBlur"
      @input="emit('input', inputVal)"
    >
      <template v-slot:prepend>
        <p v-if="prepend" class="gray--text text--darken-3 pl-2">
          {{ prepend }}
        </p>
      </template>
      <template v-slot:append>
        <v-menu
          v-model="active"
          :close-on-content-click="false"
          offset-y
          left
          class="py-2"
          content-class="menu-btn p-chip-btn--menu"
        >
          <template v-slot:activator="{ on }">
            <p-chip-icon
              icon="MergeTag"
              v-on="on"
              @click:icon="active = !active"
            />
          </template>
          <v-list v-for="item in items" :key="item.category">
            <p class="list--header text-body-2-medium info--text">
              {{ item.category }}
            </p>
            <v-list-item
              v-for="item in item.items"
              :key="item.text"
              @click="onClick(item)"
            >
              <p class="text-body-2-regular">{{ item.text }}</p>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </p-input>
  </div>
</template>

<style scoped lang="scss">
.p-chip-btn--menu {
  margin-top: 4px;
}
.list--header {
  padding: 10px 12px;
}
</style>
